import * as PortalPrimitive from '@radix-ui/react-portal'
import type { ReactNode } from 'react'

function Portal({ children, className }: { children: ReactNode; className?: string }) {
  return <PortalPrimitive.Root className={className}>{children}</PortalPrimitive.Root>
}

export { Portal }
